'use strict';

var React = require('react');
var Button = require('../../DesignSystem/Inputs/Buttons/Button/Button.js');
var Grid = require('../../DesignSystem/Layout/Grid/Grid.js');
require('prop-types');
var Add = require('../../node_modules/@material-ui/icons/Add.js');
var withStyles = require('../../node_modules/@material-ui/core/esm/styles/withStyles.js');
var Typography = require('../../node_modules/@material-ui/core/esm/Typography/Typography.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var styles = function styles(theme) {
  return {
    iconItem: {
      display: 'flex'
    },
    titlePosition: {
      position: 'absolute',
      top: 16
    },
    plusIcon: {
      display: 'flex',
      position: 'relative',
      left: 'calc(50% - 16px)'
    },
    button: {
      borderRadius: 8,
      height: '100%',
      border: '1.5px solid #2196f3',
      padding: '10px 16px',
      '&:hover': {
        border: '1.5px solid #2196f3'
      }
    },
    buttonRoot: {
      textTransform: 'none',
      color: theme.palette.black.primary
    }
  };
};

var AlternateButtonFillParent = function AlternateButtonFillParent(_ref) {
  var title = _ref.title,
      icon = _ref.icon,
      overlayIcon = _ref.overlayIcon,
      onClick = _ref.onClick,
      classes = _ref.classes;
  return React__default["default"].createElement(Button["default"], {
    variant: "outlined",
    color: "primary",
    fullWidth: true,
    onClick: onClick,
    className: classes.button,
    classes: {
      root: classes.buttonRoot
    }
  }, React__default["default"].createElement(Grid, {
    container: true
  }, React__default["default"].createElement(Grid, {
    container: true,
    spacing: 8,
    className: classes.titlePosition
  }, React__default["default"].createElement(Grid, {
    item: true,
    className: classes.iconItem
  }, icon), React__default["default"].createElement(Grid, {
    item: true
  }, React__default["default"].createElement(Typography["default"], {
    variant: "body1"
  }, title))), React__default["default"].createElement(Grid, {
    item: true,
    className: classes.plusIcon
  }, overlayIcon)));
};

AlternateButtonFillParent.defaultProps = {
  onClick: function onClick() {},
  overlayIcon: React__default["default"].createElement(Add, {
    color: "primary",
    fontSize: "large"
  })
};
var AlternateButtonFillParent$1 = withStyles(styles)(AlternateButtonFillParent);

module.exports = AlternateButtonFillParent$1;
